import CryptoJS from "crypto-js";

export const getDescryptedText = (text) => {
  // AES 암호화 대칭키
  const key = "tempKey";
  // 문자열 복호화
  const decryptedText = CryptoJS.AES.decrypt(text, key).toString(
    CryptoJS.enc.Utf8
  );
  return decryptedText;
};
